/**
 * Er verabschiedet sich — Vespera schließt mit EINEM Satz. (Ticket 2701/2717)
 *
 * Das Modell meldet den Abschied über das Werkzeug `gespraech_beenden`
 * (tools/gespraech-ende.ts); das Gerät lässt danach das Mikro zu
 * (frontend/lib/gespraech-ende.ts).
 *
 * ⚠️ Der Name steht HIER, weil ihn drei Seiten brauchen: das Werkzeug, die
 *    Regel ERSTES WORT (server/erstes-wort.ts) und das Gerät.
 */
export const ENDE_WERKZEUG = "gespraech_beenden";

/**
 * EIN Schlusssatz, auch wenn das Modell zuerst spricht. (28.09.2026, Ticket 2717)
 *
 * Das Werkzeug verlangt den Aufruf VOR jedem Text; sein Ergebnis bittet dann
 * um den einen Schlusssatz. Am echten Weg (warme Sitzung, Zusätze an jeder
 * Nachricht) sprach Sonnet in den Proben über das Abo trotzdem in rund der
 * Hälfte der Aufrufe zuerst („Alles klar, bis dann.“), rief dann das
 * Werkzeug und schloss ein zweites Mal („Bis dann.“). Eine Anweisung allein
 * hat das nicht behoben — auch nicht, dass ERSTES WORT dieses Werkzeug
 * ausnimmt.
 *
 * Die Regel darum hier, an EINER Stelle, für den Strom der warmen Sitzung:
 * Stand vor dem Aufruf schon Text in diesem Zug, ist der Schluss gesagt —
 * was danach kommt, wird weder gesendet noch gespeichert.
 *
 * ⚠️ Nur ohne andere Arbeit im Zug. Bei „leg die Notiz an, danke, tschüss“
 *    trägt der Text nach den Werkzeugen die Bestätigung („Notiz ist
 *    gespeichert“) — die darf nicht verschwinden. Lief vor dem Abschied ein
 *    anderes Werkzeug, bleibt aller Text; läuft danach eines an, gilt der
 *    Text ab dort wieder. Ein doppelter Gruß ist dort das kleinere Übel.
 *    Die Suche nach einem Werkzeug (ToolSearch) ist keine Arbeit.
 */
export interface SchlussStand {
  /** Lief in diesem Zug ein Werkzeug, das etwas tut? */
  arbeit: boolean;
  /** Ist der Schluss schon gesagt — der weitere Text dieses Zugs entfällt? */
  schweigen: boolean;
}

export function neuerSchlussStand(): SchlussStand {
  return { arbeit: false, schweigen: false };
}

/** Der Werkzeugname ohne Server-Vorsatz (`mcp__voicev8__…`, `mcp__voicev8_mehr__…`). */
export function ohneVorsatz(werkzeug: string): string {
  const i = werkzeug.lastIndexOf("__");
  return i >= 0 ? werkzeug.slice(i + 2) : werkzeug;
}

/**
 * Bei jedem Werkzeugstart im Strom.
 *
 * @param textDavor was in diesem Zug schon gesagt wurde
 */
export function schlussNachWerkzeug(stand: SchlussStand, werkzeug: string, textDavor: string): void {
  const name = ohneVorsatz(werkzeug);
  if (name === ENDE_WERKZEUG) {
    stand.schweigen = !stand.arbeit && /\S/.test(textDavor);
    return;
  }
  if (name === "ToolSearch") return;
  stand.arbeit = true;
  stand.schweigen = false;
}
